import { render } from "./sel-dialog.vue?vue&type=template&id=f21636cc&scoped=true"
import script from "./sel-dialog.vue?vue&type=script&lang=js"
export * from "./sel-dialog.vue?vue&type=script&lang=js"

import "./sel-dialog.vue?vue&type=style&index=0&id=f21636cc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21636cc"]])

export default __exports__